// extracted by mini-css-extract-plugin
module.exports = {"panel":"search-panel_panel__4fMAU","header":"search-panel_header__1kmZp","body":"search-panel_body__3cMGK"};